import { render, staticRenderFns } from "./VDataTab.vue?vue&type=template&id=3805d375&"
import script from "./VDataTab.vue?vue&type=script&lang=js&"
export * from "./VDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports